module.exports = __webpack_public_path__ + "static/stars-6494ab5b3760b5e2cc46f5566a245371.png";